import calculateCurrentIndexes from '@/components/Kanban/KPI/calculateIndex';

const sortInitiativesByActualImpact = (initiative, sortField) => {
  const { currentMonthIndex } = calculateCurrentIndexes();

  const isImpactCheck = true; // For sorting, we check both impacts and KPIs
  const isKPICheck = true;

  const dataSources = [];
  if (isImpactCheck && initiative.impact) dataSources.push(...initiative.impact);
  if (isKPICheck && initiative.KPI) dataSources.push(...initiative.KPI);

  const isValidPlanOrActual = (v) => v !== null && v !== undefined;

  // --- Handle initiatives that are On Hold/Cancelled or low stage first ---
  if (
    ['L0', 'L1', 'L2'].includes(initiative.stage) ||
    ['On Hold', 'Cancelled', 'Rejected'].includes(initiative.weeklyStatus)
  ) {
    return 'No actuals (below L3 or cancelled/on hold)';
  }

  // --- Check for 'No actuals required or no impacts' ---
  const hasNoPlanUntilCurrentMonth = !dataSources.some(d => {
    if (!d || !d.monthlyPlan) return false;
    for (let i = 0; i <= currentMonthIndex; i++) {
      if (isValidPlanOrActual(d.monthlyPlan[i])) {
        return true;
      }
    }
    return false;
  });

  const hasNoImpactOrKPI = dataSources.length === 0;
  const hasFinancialImpact = initiative.hasFinancialImpact;

  if (hasNoPlanUntilCurrentMonth || hasNoImpactOrKPI || !hasFinancialImpact) {
    return 'No actuals required or no impacts';
  }

  // --- Aggregate statuses based on the state of all data sources ---
  let hasAnyMissingLastCompleted = false;
  let hasAnyMissingPrevious = false;
  let allImpactsFilledLastCompleted = true;
  let allImpactsFilledPrevious = true;

  const lastCompletedMonthIndex = currentMonthIndex - 1;
  const previousMonthsIndices = Array.from({ length: lastCompletedMonthIndex }, (_, i) => i);

  dataSources.forEach(dataSource => {
    const previousMonthsWithPlan = previousMonthsIndices.filter(index => isValidPlanOrActual(dataSource?.monthlyPlan?.[index]));
    const lastCompletedMonthHasPlan = isValidPlanOrActual(dataSource?.monthlyPlan?.[lastCompletedMonthIndex]);

    const hasMissingActualForLastCompleted = lastCompletedMonthHasPlan && !isValidPlanOrActual(dataSource?.monthlyActual?.[lastCompletedMonthIndex]);
    const hasMissingActualForPrevious = previousMonthsWithPlan.some(index => !isValidPlanOrActual(dataSource?.monthlyActual?.[index]));

    // Update the high-level flags for the entire initiative
    if (hasMissingActualForLastCompleted) {
      hasAnyMissingLastCompleted = true;
    }
    if (hasMissingActualForPrevious) {
      hasAnyMissingPrevious = true;
    }

    // Determine if all impacts are filled
    if (lastCompletedMonthHasPlan && !isValidPlanOrActual(dataSource?.monthlyActual?.[lastCompletedMonthIndex])) {
      allImpactsFilledLastCompleted = false;
    }
    if (previousMonthsWithPlan.length > 0 && previousMonthsWithPlan.some(index => !isValidPlanOrActual(dataSource?.monthlyActual?.[index]))) {
      allImpactsFilledPrevious = false;
    }
  });

  // --- Return the single, most relevant status for sorting ---
  if (hasAnyMissingLastCompleted && hasAnyMissingPrevious) {
    return 'Missing actual in last completed and previous completed months';
  }

  if (hasAnyMissingLastCompleted) {
    return 'Missing actual in last completed month';
  }

  if (hasAnyMissingPrevious) {
    return 'Missing actual in previous months';
  }

  if (allImpactsFilledLastCompleted && allImpactsFilledPrevious) {
    return 'Filled actual (last completed and previous months required)';
  }

  if (allImpactsFilledLastCompleted) {
    return 'Filled actual (last completed month required only)';
  }

  if (allImpactsFilledPrevious) {
    return 'Filled actual (previous months required only)';
  }

  return '< not set >';
};

export default sortInitiativesByActualImpact;